<template>
    <div class="store-cta-gallery-item">
        <span class="store-title"> Visit us to see this design in-store </span>

        <a
            href="/visit-us"
            class="store-cta-button"
            @click.stop="trackCta"
            >SEE IN STORE</a
        >
        <Image
            src="https://taylorandhart.com/cms-media/2025/12/taylor-and-hart-store.jpg"
            alt="Taylor & Hap Store"
        />
    </div>
</template>

<script setup lang="ts">
import Image from '@/components/Image.vue'
import { getWindow } from '@/helpers/globals.ts'
import { useSegment } from '@/third-party/segment.ts'
const { track } = useSegment()

const trackCta = () => {
    const url = getWindow()?.location.href

    if (!url) {
        return
    }

    track('custom_see_in_store_cta_click', {
        param1: 'see_in_store_cta',
        param2: 'click',
        param3: 'pdp_gallery_tile',
        param4: url,
        url,
        event_name: 'see_in_store_cta_click',
    })
}
</script>

<style scoped lang="scss">
.store-cta-gallery-item {
    width: 100%;
    max-width: 900px;
    aspect-ratio: 1/1;
    position: relative;
    cursor: initial;
    container-name: gallery-item;
    container-type: inline-size;

    .store-title {
        position: absolute;
        width: 100%;
        padding: 0 20px;
        top: 40px;
        z-index: 2;
        color: $white;
        text-transform: uppercase;
        font-family: $effra-font-stack;
        letter-spacing: 0.02em;
        text-align: center;

        @container gallery-item (width < 340px) {
            display: none;
        }
    }

    .store-cta-button {
        position: absolute;
        bottom: 20px;
        z-index: 2;
        background: $blue;
        color: $white;
        cursor: pointer;
        display: block;
        text-transform: uppercase;
        font-family: $effra-font-stack;
        font-size: 0.875rem;
        letter-spacing: 0.05em;
        line-height: 20px;
        padding: 11px 10px 9px;
        border-radius: 20px;
        width: 150px;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;

        @container gallery-item (width < 340px) {
            bottom: auto;
            top: 30px;
            background: $white;
            color: $blue;
        }
    }
}
</style>
